import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=d6307c3e&"
import script from "./EmailDetail.vue?vue&type=script&lang=js&"
export * from "./EmailDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports